import find from 'lodash/find';
import classNames from 'classnames';
import { DEPARTURE, RETURN }
  from 'components/components/booking/utils/FlightConstants';
import {
  HOME_TYPE,
  WORK_TYPE,
  OTHER_TYPE
} from 'components/common/constants/addressTypesConstants';

const getIconName = (type, defaultIcon) => {
  var iconName = defaultIcon;
  if (type) {
    if (type === HOME_TYPE) {
      iconName = "home";
    } else if (type === WORK_TYPE) {
      iconName = "briefcase";
    } else if (type === OTHER_TYPE) {
      iconName = "star";
    }
  }
  return iconName;
}

export const jumpingMarkerData = (
  addressMarker,
  busStops,
  direction = null
) => {
  if (addressMarker) {
    if (addressMarker.g) {
      // google street
      return {
        lat: addressMarker.lat,
        lng: addressMarker.lng,
        icon: getIconName(addressMarker.type, 'map-marker-alt'),
        label: addressMarker.label,
        direction: direction
      }
    } else {
      //bus stop is selected
      var busStop = find(
        busStops,
        (o, key) => key === addressMarker.value
      );
      return {
        lat: busStop.lat,
        lng: busStop.lng,
        icon: getIconName(addressMarker.type, 'bus'),
        label: addressMarker.label,
        direction: direction
      }
    }
  } else {
    return null;
  }
}

export const classNameOfMarker = (marker) => {
  return classNames(
    'marker',
    {
      'marker--0': marker.direction === DEPARTURE ||
        !marker.direction
    },
    { 'marker--1': marker.direction === RETURN }
  );
}
